import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import FileDownload from 'js-file-download';

import { rest } from '../utils/rest';
import AuthContext from '../contexts/AuthContext';
import ToastContext from '../contexts/ToastContext';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

export const DOWNLOAD_FAILED_MESSAGE =
  'Report download failed. Try again, or narrow the report with filters.';

export const downloadReport = props => {
  const {
    path, filename, credentials, params, type, setDownloading, onError
  } = props;
  setDownloading(type);

  const options = {
    credentials,
    params,
    path: `report-builder/${path}.xlsx`,
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  };

  const timestamp = new Date().getTime();
  let fullFilename = `${filename || path}-${timestamp}.xlsx`;

  if ('pdf' === type) {
    options.path = `report-builder/${path}.pdf`;
    options.headers.Accept = 'application/pdf';
    // increase timeout for PDF generation/download (5 minutes)
    options.timeout = 5 * 60 * 1000;
    fullFilename = `${filename || path}-${timestamp}.pdf`;
  };

  return rest(options).then(response => {
    if (!response.ok) {
      throw new Error(`Report request failed with status ${response.status}`);
    }
    return response.blob();
  }).then(blob => {
    FileDownload(blob, fullFilename);
  }).catch(error => {
    if (onError) { onError(error); }
  }).finally(() => {
    setDownloading(false);
  });
};

export const DownloadButton = ({ label, handleDownload, children, noExcel, noPdf }) => {
  const [downloading, setDownloading] = useState();
  const { credentials } = useContext(AuthContext);
  const toast = useContext(ToastContext);

  const busy = Boolean(downloading);

  const onError = () => {
    if (toast) { toast.notify(DOWNLOAD_FAILED_MESSAGE, toast.standard); }
  };

  return (
    <View>
      <ButtonGroup>
        {!noExcel &&
          <Button
            label="Download Excel"
            loading={'xlsx' === downloading}
            disabled={busy}
            onPress={() => (
              handleDownload({ credentials, type: 'xlsx', setDownloading, onError })
            )}
          />
        }
        {!noPdf &&
          <Button
            label="Download PDF"
            loading={'pdf' === downloading}
            disabled={busy}
            onPress={() => (
              handleDownload({ credentials, type: 'pdf', setDownloading, onError })
            )}
          />
        }
        {children}
      </ButtonGroup>
    </View>
  );
};
